const vgh = {
  sparkasse: {
    produkt: 'Glasversicherung',
  },
  prepage: {
    pageTitle: 'Glasversicherung',
    headline: 'Die $t(mandant) Glasversicherung',
    leistungenIntro: '',
    leistungen: [
      'Absicherung von Bruchschäden',
      'An Mobiliar- und Gebäudeverglasungen',
      'Unabhängig von der Schadenursache',
    ],
  },
  produktvergleich: {
    glas_mobiliar: {
      label: '',
      leistungen: {
        glasbruch: 'Glasbruchschäden unabhängig von der Schadenursache',
        folgekosten: 'Mehr- und Folgekosten',
        mobiliar: 'Mobiliarverglasung',
      },
      keineLeistungen: {
        gebaeude: 'Gebäudeverglasung',
      },
    },
    glas_gebaeude: {
      label: '',
      leistungen: {
        glasbruch: 'Glasbruchschäden unabhängig von der Schadenursache',
        folgekosten: 'Mehr- und Folgekosten',
        mobiliar: 'Mobiliarverglasung',
        gebaeude: 'Gebäudeverglasung',
      },
    },
    produkte: {
      glasbruch: `<h4>Glasbruchschäden</h4>
        <p>Unsere Glasversicherung springt ein, wenn nach einem Bruchschaden die versicherte Innen- und/oder Außenverglasung 
        ersetzt werden muss. Wir erstatten die Kosten für den Ersatz der versicherten Verglasung in gleicher Art und 
        Güte – und zwar unabhängig von der Schadenursache.</p>`,
      folgekosten: `<h4>Mehr- und Folgekosten</h4>
        <p>Wir übernehmen Mehrkosten durch behördliche Vorschriften wie zum Beispiel eine neue Energieeinsparverordnung. 
        Auch Einbau und Entsorgung der beschädigten Verglasung sind natürlich inklusive. Sollte kurzfristig eine 
        Notverglasung erforderlich sein, übernehmen wir auch diese Kosten.</p>`,
      mobiliar: `<h4>Mobiliarverglasung</h4>
        <p>Versichert sind Mobiliarverglasungen von Bildern, Schränken, Vitrinen; Stand-, Wand- und Schrankspiegeln; 
        Glasplatten; Glasscheiben und Sichtfenster von Öfen, Elektro- und Gasgeräten; Aquarien/Terrarien, Platten aus 
        Glaskeramik und Glaskeramik-Kochflächen.</p>`,
      gebaeude: `<h4>Gebäudeverglasung<h4>
        <p>Versichert sind Gebäudeverglasungen von Fenstern, Türen, Balkonen, Terrassen, Wänden, Wintergärten, Veranden, 
        Loggien, Wetterschutzvorbauten, Dächern, Brüstungen, Duschkabinen, Lichtkuppeln, Sonnenkollektoren einschließlich 
        Rahmen, Glasbausteinen und Profilbaugläsern.</p>
        <p>Außerdem sind bis jeweils 10.000 € je Schadenfall mitversichert: künstlerisch bearbeitete Glasscheiben, 
        -spiegel und -platten; Sonderkosten für Gerüste, Kräne oder Ähnliches; Beseitigung und Wiederanbringen von 
        Hindernissen wie Markisen oder Schutzgittern; Erneuerung von Anstrichen, Malereien, Schriften, Verzierungen, 
        Folien; Schäden an Umrahmungen, Mauerwerk, Schutzeinrichtungen; Verglasungen von privat genutzten Gewächshäusern 
        und Schwimmbadabdeckungen auf dem Wohngrundstück.</p>`,
    },
    links: {
      leistungsuebersicht: '',
      versBedingungenGlas: '<a target="_blank" rel="noopener noreferrer"'
        + ' data-tracking-name="link-versicherungsbedingungen-glas"'
        + ' href="$t(produktvergleich.links.versBedingungenGlasLink)">Versicherungsbedingungen für die Haushalt-Glasversicherung</a>',
    },
  },
  personendaten: {
    anschrift_tt: `<h4>Anschrift</h4>
    <p>Ihre Glasversicherung gilt für die hier genannte Adresse.</p>
    <ul class="list-icn-checkbullet">
      <li><strong>Sie möchten Ihre Verglasung an einer anderen Adresse versichern?</strong> Dann nutzen Sie bitte den Link "Anschrift ändern >".</li>
    </ul>`,
  },
};

export default vgh;
